/* eslint-disable no-useless-escape */
// SEO landing pages configuration. Each entry generates a fully-templated
// page consumed by <SeoLandingPage />. Keep bodies natural, keyword-inclusive
// but never spammy.

export const SEO_PAGES = {
  "livraison-a-domicile-cotonou": {
    slug: "/livraison-a-domicile-cotonou",
    title: "Livraison à domicile à Cotonou | Zafara Bénin",
    metaDescription:
      "Livraison à domicile à Cotonou avec Zafara : commandes en 30 min, tout Cotonou couvert, paiement Mobile Money. Télécharge l'app iOS & Android.",
    keyword: "Livraison Cotonou",
    breadcrumb: "Livraison à domicile Cotonou",
    h1: "Livraison à domicile à Cotonou — rapide, tracée, béninoise.",
    intro:
      "Avec Zafara, tu commandes sur l'app et un livreur béninois indépendant t'apporte tes achats à domicile ou au bureau. Tout Cotonou est couvert, du centre à Cadjéhoun, Fidjrossè, Akpakpa ou Gbégamey. Paiement Mobile Money MTN & Moov, suivi GPS du livreur en direct dans l'app.",
    ctaPrimary: "Télécharger l'app Zafara",
    ctaSecondary: "Voir le catalogue",
    highlights: [
      {
        title: "Livraison rapide dans tout Cotonou",
        body: "Nos livreurs indépendants sillonnent la ville chaque jour. Objectif : livrer tes courses ou tes achats en 30 à 90 minutes selon le quartier.",
        bullets: ["Cadjéhoun · Fidjrossè · Haie Vive", "Akpakpa · Placodji · Vodjè", "Gbégamey · Cocotomey · Calavi Centre"],
      },
      {
        title: "Suivi GPS du livreur en direct",
        body: "Dès que ta commande est validée, tu vois ton livreur sur la carte en temps réel dans l'app — tu suis sa progression jusqu'à ta porte, étape par étape : confirmée, prise en charge, en route, livrée.",
      },
      {
        title: "Paiement Mobile Money sécurisé",
        body: "Paye par MTN Mobile Money, Moov Money ou en espèces à la livraison. Aucun compte bancaire nécessaire, aucun frais caché.",
      },
    ],
    steps: [
      {
        title: "Tu commandes depuis l'app",
        body: "Parcours le catalogue, ajoute au panier, choisis ton quartier et confirme.",
      },
      {
        title: "Un livreur récupère ta commande",
        body: "Nos livreurs indépendants récupèrent ton colis chez le vendeur en quelques minutes.",
      },
      {
        title: "Livré chez toi, tracé en direct",
        body: "Tu reçois ton produit à domicile avec ton code unique, position GPS du livreur mise à jour en temps réel dans l'app.",
      },
    ],
    faq: [
      { q: "Combien de temps prend une livraison à Cotonou ?", a: "En général entre 30 et 90 minutes selon ton quartier et l'heure de commande. Tu vois l'estimation avant de payer." },
      { q: "Quels quartiers de Cotonou sont couverts ?", a: "Tout Cotonou est couvert : Cadjéhoun, Fidjrossè, Haie Vive, Akpakpa, Placodji, Vodjè, Gbégamey, Cocotomey, ainsi que Abomey-Calavi (Calavi Centre, Godomey)." },
      { q: "Combien coûte la livraison ?", a: "Les frais varient selon la distance, à partir de 500 F CFA. Le prix exact s'affiche avant confirmation du paiement." },
      { q: "Puis-je payer à la livraison ?", a: "Oui, tu peux payer en espèces à la livraison. Sinon MTN Mobile Money ou Moov Money via l'app en 1 clic." },
      { q: "Comment suivre ma commande ?", a: "Après confirmation, tu suis ton livreur en direct sur la carte de l'app Zafara — position GPS mise à jour en temps réel jusqu'à ta porte. Tu reçois aussi un code de suivi consultable sur zafarabenin.fr/suivi." },
    ],
  },

  "courses-en-ligne-cotonou": {
    slug: "/courses-en-ligne-cotonou",
    title: "Courses en ligne à Cotonou | Livraison rapide Zafara",
    metaDescription:
      "Fais tes courses en ligne à Cotonou avec Zafara. Épicerie, produits frais, hygiène, tout livré à domicile en Mobile Money. Télécharge l'app.",
    keyword: "Courses en ligne Cotonou",
    breadcrumb: "Courses en ligne Cotonou",
    h1: "Fais tes courses en ligne à Cotonou — livrées chez toi.",
    intro:
      "Plus besoin de courir au marché ou de faire la queue au supermarché. Sur Zafara, tu choisis tes produits sur l'application, tu payes par Mobile Money et un livreur t'apporte tout à domicile. Simple, rapide, béninois.",
    ctaPrimary: "Commander maintenant sur l'app",
    highlights: [
      {
        title: "Un catalogue local et varié",
        body: "Nos commerçants partenaires proposent l'essentiel : épicerie, boissons, hygiène, bébé, cosmétique, quincaillerie. Le catalogue s'enrichit chaque semaine.",
      },
      {
        title: "Prix affichés, aucune surprise",
        body: "Chaque article a un prix clair en francs CFA. Les frais de livraison sont annoncés avant paiement.",
      },
      {
        title: "Livraison à domicile ou au bureau",
        body: "Tu choisis ton adresse, ton quartier, et un livreur béninois t'apporte tes courses en moins de 90 minutes dans Cotonou.",
      },
    ],
    steps: [
      { title: "Télécharge l'app Zafara", body: "Gratuit sur App Store & Google Play, en 2 minutes." },
      { title: "Ajoute au panier", body: "Parcours l'épicerie, sélectionne tes produits, choisis quantités." },
      { title: "Paye et sois livré", body: "Mobile Money ou paiement à la livraison. Suivi GPS du livreur en direct dans l'app." },
    ],
    faq: [
      { q: "Est-ce que Zafara livre des produits frais ?", a: "Oui, une partie des vendeurs partenaires propose des produits frais et périssables — la livraison rapide (moins d'une heure) permet de les recevoir en bon état." },
      { q: "Zafara est-elle gratuite ?", a: "L'application est 100% gratuite. Tu payes uniquement les produits commandés et les frais de livraison (à partir de 500 F CFA)." },
      { q: "Quels moyens de paiement ?", a: "MTN Mobile Money, Moov Money, ou paiement en espèces à la livraison." },
      { q: "Puis-je annuler ma commande ?", a: "Oui, tant qu'un livreur n'a pas été assigné, tu peux annuler directement depuis l'application." },
    ],
  },

  "epicerie-en-ligne-cotonou": {
    slug: "/epicerie-en-ligne-cotonou",
    title: "Épicerie en ligne à Cotonou | Zafara — livraison rapide",
    metaDescription:
      "Épicerie en ligne à Cotonou : commande riz, huile, boissons, produits frais et fais-toi livrer à domicile. Paiement Mobile Money via l'app Zafara.",
    keyword: "Épicerie en ligne Cotonou",
    breadcrumb: "Épicerie en ligne Cotonou",
    h1: "L'épicerie en ligne à Cotonou, dans ton téléphone.",
    intro:
      "Riz, huile, pâtes, boissons, produits d'hygiène, bébé, cosmétique — l'essentiel du quotidien à Cotonou, commandé en 2 minutes et livré chez toi. Zafara sélectionne des commerces locaux de confiance, pour que tu retrouves les marques que tu connais.",
    highlights: [
      {
        title: "Produits du quotidien",
        body: "Alimentation, boissons, hygiène, bébé, ménage. Les rayons se remplissent avec les commerçants béninois du réseau.",
      },
      {
        title: "Livraison partout à Cotonou",
        body: "Tout Cotonou est couvert, plus Abomey-Calavi. Livraison en moins de 90 minutes dans la plupart des quartiers.",
      },
      {
        title: "Paiement 100% Bénin",
        body: "MTN Mobile Money ou Moov Money — les moyens de paiement des Béninois. Espèces acceptées à la livraison.",
      },
    ],
    steps: [
      { title: "Ouvre le catalogue", body: "Choisis « Alimentation » ou « Hygiène » et remplis ton panier." },
      { title: "Confirme ta commande", body: "Adresse, quartier, mode de paiement — tout se fait dans l'app." },
      { title: "Livraison chez toi", body: "Un livreur t'apporte tes courses en moins de 90 minutes." },
    ],
    faq: [
      { q: "Puis-je commander pour toute la famille ?", a: "Oui, il n'y a pas de limite : commande pour toi, tes enfants, tes parents. Adresse de livraison personnalisable à chaque commande." },
      { q: "Comment savoir si un produit est disponible ?", a: "Chaque produit affiche son stock en temps réel. Un badge « rupture » apparaît si l'article n'est plus disponible." },
      { q: "Y a-t-il des promotions ?", a: "Oui, les vendeurs partenaires publient régulièrement des offres. Active les notifications sur l'app pour ne rien rater." },
    ],
  },

  "acheter-en-ligne-benin": {
    slug: "/acheter-en-ligne-benin",
    title: "Acheter en ligne au Bénin | Marketplace Zafara",
    metaDescription:
      "La marketplace béninoise pour acheter en ligne partout au Bénin. Produits vérifiés, livraison Mobile Money, app gratuite iOS & Android.",
    keyword: "Acheter en ligne Bénin",
    breadcrumb: "Acheter en ligne Bénin",
    h1: "Acheter en ligne au Bénin — sur une marketplace 100% béninoise.",
    intro:
      "Zafara est la marketplace du Bénin pour acheter en toute confiance. Vendeurs vérifiés, produits en stock réel, paiement Mobile Money, livraison par des livreurs indépendants béninois. Le e-commerce fait pour et par le Bénin.",
    highlights: [
      {
        title: "Vendeurs vérifiés au Bénin",
        body: "Chaque commerçant est identifié, ses coordonnées confirmées. Fini les mauvaises surprises des groupes WhatsApp anonymes.",
      },
      {
        title: "Livraison couvre le Bénin",
        body: "Priorité Cotonou et sa région (Abomey-Calavi, Godomey). L'app s'étend progressivement à Porto-Novo, Parakou et l'intérieur du pays.",
      },
      {
        title: "Support en français, WhatsApp",
        body: "Une équipe basée au Bénin, joignable en français et par WhatsApp, pour toute question ou réclamation.",
      },
    ],
    steps: [
      { title: "Crée ton compte", body: "En 30 secondes avec ton numéro WhatsApp." },
      { title: "Commande ce que tu veux", body: "Explore le catalogue et paye en Mobile Money." },
      { title: "Reçois ton achat", body: "Livreur béninois indépendant, suivi GPS en direct dans l'app." },
    ],
    faq: [
      { q: "Dans quelles villes du Bénin Zafara fonctionne ?", a: "Priorité aujourd'hui : Cotonou et Abomey-Calavi. Extension progressive à Porto-Novo et Parakou dans les mois à venir." },
      { q: "Zafara est-elle vraiment béninoise ?", a: "Oui : édité par Whilsco-Digit (Île Maurice + Bénin), fondé par un ingénieur béninois. Vendeurs, livreurs et support tous basés au Bénin." },
      { q: "Puis-je acheter depuis l'étranger pour ma famille ?", a: "Absolument. Beaucoup d'utilisateurs de la diaspora commandent pour leurs proches restés au Bénin. Adresse de livraison différente autorisée." },
      { q: "Y a-t-il une garantie ?", a: "Oui : paiement sécurisé, produits vérifiés, remboursement en cas de problème conforme aux CGU disponibles sur zafarabenin.fr/mentions-legales." },
    ],
  },

  "devenir-vendeur": {
    slug: "/devenir-vendeur",
    title: "Devenir vendeur sur Zafara Bénin | Vends en ligne au Bénin",
    metaDescription:
      "Deviens vendeur sur Zafara : ouvre ta boutique en ligne au Bénin, gère ton catalogue depuis l'app, paiement Mobile Money instantané.",
    keyword: "Devenir vendeur Bénin",
    breadcrumb: "Devenir vendeur",
    h1: "Deviens vendeur sur Zafara — ouvre ta boutique en ligne au Bénin.",
    intro:
      "Tu tiens une boutique à Cotonou ou ailleurs au Bénin ? Rejoins Zafara et vends en ligne dès aujourd'hui. Aucun site web à créer, aucun développeur à payer : tu gères tout depuis ton téléphone.",
    ctaPrimary: "Télécharger l'app Vendeur",
    ctaSecondary: "Voir le catalogue",
    highlights: [
      {
        title: "Ouvre ta boutique en 5 minutes",
        body: "Prends une photo, ajoute un titre, un prix. Ton produit est en ligne. Aucun formulaire compliqué, aucun frais d'inscription.",
      },
      {
        title: "Paye et sois payé en Mobile Money",
        body: "Tu reçois tes ventes directement sur MTN Mobile Money ou Moov Money. Argent versé à chaque commande livrée.",
      },
      {
        title: "Zafara amène les clients",
        body: "L'application met tes produits en avant auprès de milliers de Béninois qui commandent depuis Cotonou et sa région.",
      },
    ],
    steps: [
      { title: "Télécharge l'app Zafara", body: "iOS ou Android, gratuit." },
      { title: "Passe en mode Vendeur", body: "Choisis « Ouvrir une boutique » et remplis 3 champs (nom, ville, quartier)." },
      { title: "Publie tes produits", body: "Photos, prix, stock. Tu gères tout depuis ton téléphone." },
    ],
    faq: [
      { q: "Combien coûte l'inscription vendeur ?", a: "L'inscription est gratuite. Zafara prélève une petite commission de 17% sur chaque vente livrée (comme précisé dans les paramètres publics de la plateforme)." },
      { q: "Quels produits puis-je vendre ?", a: "Épicerie, mode, cosmétique, quincaillerie, électronique, produits pour bébé, etc. Certaines catégories sont interdites (produits illégaux, contrefaçons)." },
      { q: "Comment sont livrés mes produits ?", a: "Tu prépares le colis, un livreur Zafara indépendant vient le chercher chez toi et l'apporte au client. Tu ne gères pas la logistique." },
      { q: "Suis-je responsable des retours ?", a: "En cas de produit défectueux ou non conforme, la politique de retour s'applique — Zafara facilite la médiation entre toi et le client." },
    ],
  },

  "devenir-livreur": {
    slug: "/devenir-livreur",
    title: "Devenir livreur Zafara Bénin | Livraison indépendant Cotonou",
    metaDescription:
      "Deviens livreur Zafara indépendant à Cotonou. Choisis tes horaires, gagne en Mobile Money à chaque livraison. Rejoins nos livreurs béninois.",
    keyword: "Devenir livreur Cotonou",
    breadcrumb: "Devenir livreur",
    h1: "Deviens livreur indépendant Zafara à Cotonou.",
    intro:
      "Tu as une moto et tu veux gagner ta vie librement ? Rejoins le réseau des livreurs indépendants Zafara à Cotonou. Tu choisis quand tu travailles, tu gagnes en Mobile Money à chaque course.",
    ctaPrimary: "Télécharger l'app Livreur",
    ctaSecondary: "Voir comment ça marche",
    highlights: [
      {
        title: "Travaille quand tu veux",
        body: "Aucun contrat contraignant. Tu te connectes quand tu veux livrer, tu te déconnectes quand tu arrêtes.",
      },
      {
        title: "Paiement Mobile Money direct",
        body: "Tu reçois ta rémunération sur MTN Mobile Money ou Moov Money, jour après jour. Pas de longs délais de virement.",
      },
      {
        title: "Support et sécurité",
        body: "Notre équipe est joignable sur WhatsApp en cas de souci. Nous accompagnons les livreurs au démarrage.",
      },
    ],
    steps: [
      { title: "Télécharge l'app Zafara", body: "Depuis App Store ou Google Play, choisis « Devenir livreur »." },
      { title: "Fournis moto + pièce d'identité", body: "Photo de ta pièce, de ta moto et plaque d'immatriculation." },
      { title: "Commence à livrer", body: "Une fois validé, tu vois les courses disponibles dans ton quartier." },
    ],
    faq: [
      { q: "Faut-il un permis moto ?", a: "Oui, tu dois pouvoir présenter tes papiers en règle (permis, carte grise, assurance)." },
      { q: "Combien peut-on gagner par jour ?", a: "Cela dépend du nombre de courses acceptées. Nos livreurs actifs à Cotonou gagnent en général entre 3 000 et 8 000 F CFA/jour selon les horaires." },
      { q: "Zafara fournit-elle la moto ?", a: "Non, tu dois avoir ta propre moto. Nous discutons de partenariats moto avec des acteurs locaux — reste à l'écoute dans l'app." },
      { q: "Est-ce que c'est un salariat ?", a: "Non, tu es livreur indépendant : tu factures tes courses via la plateforme, tu es libre de tes horaires. Zafara n'est pas ton employeur." },
    ],
  },
};

export const SEO_PAGE_LIST = Object.values(SEO_PAGES);
